/**
 * @generated SignedSource<<1d8c448f51169523f40ef830f3470245>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs$data = {
  readonly key: string;
  readonly name: string;
  readonly " $fragmentType": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs";
};
export type breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs$key = {
  readonly " $data"?: breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs$data;
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "ed2f4bc001a364f753ffebfa5a1fa48e";

export default node;
